:host {
    display: block;

    @media screen and (max-width: 767px) {
        margin: 0 auto;
        max-width: 20rem;
    }
}

#donation-section-wrapper {
    padding: 20px;

    h3 {
        margin-bottom: 15px;

        @media screen and (max-width: 767px) {
            font-size: var(--fs-sm);
        }
        
        span {
            font-weight: 300;
            padding-left: 5px;
        }
    }
    
    .price-point-wrapper {
        margin: 0 auto;
        max-width: 520px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
    }
}